// extracted by mini-css-extract-plugin
export default {"textlarge":"Category_textlarge__JHJlS"};